












































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator';

@Component
export default class ChartRunningPhaseComparisonTable extends Vue {
  @Prop({ default: null }) _firstValue: any;
  @Prop({ default: null }) _secondValue: any;
  @Prop() isComparisonPage!: boolean;
  @Prop() _values: any;
  @Prop({ default: false }) isNewAnalysis!: boolean;

  sides = ['left', 'right'];
  compareData: any = [];
  badCompareData = false;

  get values() {
    return this.isComparisonPage ? this._values.computed_data : this._values;
  }
  get firstValue() {
    return this.isComparisonPage ? this._firstValue.computed_data : this._firstValue;
  }
  get secondValue() {
    if (this.badCompareData) {
      return null;
    } else {
      return this.isComparisonPage ? this._secondValue.computed_data : this._secondValue;
    }
  }

  get currentFirstVal() {
    return this.isComparisonPage ? 'firstValue' : 'values';
  }
  get currentSecondVal() {
    return this.isComparisonPage ? 'secondValue' : 'values';
  }

  get globalCadence() {
    return this.isComparisonPage
      ? {
          firstVal: this.firstValue.aggregates.left.cadence.avg + this.firstValue.aggregates.right.cadence.avg,
          secondVal: this.secondValue
            ? this.secondValue.aggregates.left.cadence.avg + this.secondValue.aggregates.right.cadence.avg
            : null,
        }
      : {
          firstVal:
            this.values.segments[this.firstValue.index].left.result.aggregates.cadence.avg +
            this.values.segments[this.firstValue.index].right.result.aggregates.cadence.avg,
          secondVal: this.secondValue
            ? this.values.segments[this.secondValue.index].left.result.aggregates.cadence.avg +
              this.values.segments[this.secondValue.index].right.result.aggregates.cadence.avg
            : null,
        };
  }
  get globalSpeed() {
    return this.isComparisonPage
      ? {
          firstVal:
            (this.firstValue.aggregates.left.running_speed.avg + this.firstValue.aggregates.right.running_speed.avg) /
            2,
          secondVal: this.secondValue
            ? (this.secondValue.aggregates.left.running_speed.avg +
                this.secondValue.aggregates.right.running_speed.avg) /
              2
            : null,
        }
      : {
          firstVal:
            (this.values.segments[this.firstValue.index].left.result.aggregates.running_speed.avg +
              this.values.segments[this.firstValue.index].right.result.aggregates.running_speed.avg) /
            2,
          secondVal: this.secondValue
            ? (this.values.segments[this.secondValue.index].left.result.aggregates.running_speed.avg +
                this.values.segments[this.secondValue.index].right.result.aggregates.running_speed.avg) /
              2
            : null,
        };
  }

  get segments() {
    if (!this.isComparisonPage) {
      return this.values.segments;
    } else {
      return [];
    }
  }

  @Watch('_secondValue', { deep: true })
  onSecondValueChange() {
    this.badCompareData = this.isComparisonPage && !this._secondValue.computed_data.aggregates.left.percent_flight_time;
  }

  getData(side: string, data: string, index: number, val: string, rounded: number) {
    // @ts-ignore
    if (this.isComparisonPage) {
      // @ts-ignore
      return parseFloat(this[val].aggregates[side][data].avg.toFixed(rounded));
    } else {
      return parseFloat(this.values.segments[index][side].result.aggregates[data].avg.toFixed(rounded));
    }
  }
  getSymmetry(index: number, val: string) {
    const leftFlight = this.getData('left', 'contact_time', index, val, 3);
    const rightFlight = this.getData('right', 'contact_time', index, val, 3);

    let substrack = (rightFlight - leftFlight) * 100;
    let add = (rightFlight + leftFlight) / 2;

    if (substrack && add) {
      const result = substrack / add;

      const isNegativeSymmetry = result < 0;
      const absResult = Math.abs(result);

      let range;
      switch (true) {
        case absResult < 2.5:
          range = 'warning';
          break;
        case absResult > 2.5 && absResult < 5:
          range = 'success';
          break;
        case absResult > 5 && absResult < 10:
          range = 'warning';
          break;
        default:
          range = 'error';
      }

      const left = isNegativeSymmetry ? 50 + absResult : 50 - absResult;
      const right = isNegativeSymmetry ? 50 - absResult : 50 + absResult;
      const leftProgress = absResult * 2.5;
      const rightProgress = absResult * 2.5;

      return {
        range: range,
        value: parseFloat((absResult / 2).toFixed(1)),
        leftProgress: leftProgress,
        rightProgress: rightProgress,
        isLeftSideSymmetry: left > right,
      };
    } else {
      return {
        range: 'neutral',
        value: 0,
        leftProgress: 50,
        rightProgress: 50,
        isLeftSideSymmetry: false,
      };
    }
  }
  getForeFoot(side: string, index: number, val: string) {
    const that: any = this;
    // Is aggregates values
    if (this.isComparisonPage) {
      const value = that[`_${val}`].computed_data.aggregates;
      let isLastAnalysis = value[side].percent_fore_foot === undefined && value[side].percent_mid_foot === undefined;

      // Is new results
      if (!isLastAnalysis) {
        const highestValue = Math.max(
          value[side].percent_fore_foot,
          value[side].percent_mid_foot,
          value[side].percent_rear_foot,
        );
        if (highestValue === value[side].percent_fore_foot) {
          return 'attack-toe';
        } else if (highestValue === value[side].percent_rear_foot) {
          return 'attack-heel';
        } else {
          return 'attack-flat';
        }
      }
      // Is last results
      else {
        let _count: number = 0;
        for (const seg of that[`_${val}`].computed_data.segments) {
          if (seg[side].result.scalars.fore_foot) {
            _count = _count + 1;
          }
        }
        if (that[`_${val}`].computed_data.segments.length / 2 < _count) {
          return 'attack-toe';
        } else {
          return 'attack-heel';
        }
      }
    }

    // Is segments values
    else {
      let isLastAnalysis =
        this.segments[index][side].result.scalars.mid_foot === undefined &&
        this.segments[index][side].result.scalars.rear_foot === undefined;
      // Is last results
      if (isLastAnalysis) {
        return this.segments[index][side].result.scalars.fore_foot ? 'attack-toe' : 'attack-heel';
      }
      // Is new results
      else {
        const highestValue = Math.max(
          this.segments[index][side].result.scalars.fore_foot,
          this.segments[index][side].result.scalars.mid_foot,
          this.segments[index][side].result.scalars.rear_foot,
        );
        if (
          this.segments[index][side].result.scalars.fore_foot === 0 &&
          this.segments[index][side].result.scalars.mid_foot === 0 &&
          this.segments[index][side].result.scalars.rear_foot === 0
        ) {
          return 'attack-flat';
        }
        if (highestValue === this.segments[index][side].result.scalars.fore_foot) {
          return 'attack-toe';
        } else if (highestValue === this.segments[index][side].result.scalars.rear_foot) {
          return 'attack-heel';
        } else {
          return 'attack-flat';
        }
      }
    }
  }
  getDoubleFlight(index: number, val: string) {
    let flight_time =
      this.getData('left', 'percent_flight_time', index, val, 3) +
      this.getData('right', 'percent_flight_time', index, val, 3);

    let global_flight_time = flight_time / 2;

    let contact_time =
      this.getData('left', 'percent_contact_time', index, val, 3) +
      this.getData('right', 'percent_contact_time', index, val, 3);

    let global_contact_time = contact_time / 2;

    return ((global_flight_time - global_contact_time) / 2).toFixed(0);
  }
  getDifference(firstValue: number, secondValue: number) {
    switch (true) {
      case secondValue > firstValue:
        return 'long-arrow-up';
      case secondValue < firstValue:
        return 'long-arrow-down';
      default:
        return 'long-arrow-right';
    }
  }
  getDuration(idx: number) {
    let globalSpeed =
      this.segments[idx]?.left && this.segments[idx]?.right
        ? (this.segments[idx]?.left.header.start_time + this.segments[idx]?.right.header.start_time) / 2
        : null;
    return !globalSpeed
      ? 0
      : (this.$moment as any)
          .duration({
            seconds: globalSpeed / 32768,
          })
          .asMilliseconds();
  }

  getTimeClass(firstValue: boolean, indexPosition: number) {
    if (!this.secondValue) {
      return 'first-time-value';
    } else if (this.firstValue.indexPosition < this.secondValue.indexPosition) {
      return firstValue ? 'first-time-value' : 'second-time-value';
    } else {
      return firstValue ? 'second-time-value' : 'first-time-value';
    }
  }
}
